// src/trello/user/types.ts
var TrelloUserAriResourceOwner = "trello", TrelloUserAriResourceType = "user";

export {
  TrelloUserAriResourceOwner,
  TrelloUserAriResourceType
};
